// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3qlcL","col":"styles_col__220_W","fulfillmentStatus":"styles_fulfillmentStatus__1aakz","emailCol":"styles_emailCol__1xZSP"};